var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"product-button",attrs:{"disabled":_vm.disabled},on:{"click":_vm.handleClick}},[_c('i',{staticClass:"mdi mdi-package-variant product-icon"}),_c('span',{staticClass:"product-name"},[_vm._v(_vm._s(_vm.product.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }